import React from "react";
import { IoMdCheckmark } from "react-icons/io";
import SignUpImage from "../images/image-5.png";
import SignUpForm1 from "./SignUpForm1";
import VisitorsHeader from "../component/vistorsheader";
import Bottom from "../component/bottom-section";
import Footer from "../component/footer";



const Register1 = ({ code }) => {
  const currentStep = 1;

  const steps = [
    { number: 1, title: "Step 01" },
    { number: 2, title: "Step 02" },
    { number: 3, title: "Step 03" },
    { number: 4, title: "Step 04" },
  ];

  return (
    <div>
      <VisitorsHeader />
      <>
        <div className="flex py-4 my-3 w-[95%] lg:w-[85%] mx-auto flex-col lg:flex-row min-h-screen justify-between">
          <div className="md:hidden hidden lg:block">
            <img
              src={SignUpImage}
              alt="Sign Up"
              className=" h-full"
            />
          </div>

          <div className="flex items-center justify-center lg:px-8 px-3 mt-16">
            <div className="max-w-lg w-full">
              <div className="mb-12">
                <div className="relative flex items-center justify-between">
                  {steps.map((s, index) => {
                    if (index < steps.length - 1) {
                      return (
                        <div
                          key={`line-${index}`}
                          className="absolute h-1 bg-gray-300"
                          style={{
                            left: `${(index * 100) / (steps.length - 1)}%`,
                            right: `${
                              100 - ((index + 1) * 100) / (steps.length - 1)
                            }%`,
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}
                        />
                      );
                    }
                    return null;
                  })}

                  {/* Active progress lines */}
                  {steps.map((s, index) => {
                    if (index < steps.length - 1 && index < currentStep) {
                      return (
                        <div
                          key={`active-line-${index}`}
                          className="absolute h-1 bg-[#405AC6] transition-all duration-300"
                          style={{
                            left: `${(index * 100) / (steps.length - 1)}%`,
                            right: `${
                              100 - ((index + 1) * 100) / (steps.length - 1)
                            }%`,
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}
                        />
                      );
                    }
                    return null;
                  })}

                  {steps.map((s) => (
                    <div
                      key={s.number}
                      className="relative z-10 flex flex-col items-center"
                    >
                      <div
                        className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 border-2 ${
                          s.number < currentStep
                            ? "bg-[#405AC6] border-[#405AC6] text-white"
                            : s.number === currentStep
                            ? "bg-white border-[#405AC6] text-[#405AC6]"
                            : "bg-white border-gray-300 text-gray-500"
                        }`}
                      >
                        {s.number < currentStep ? (
                          <IoMdCheckmark className="w-5 h-5" />
                        ) : (
                          `0${s.number}`
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <SignUpForm1 code={code} />
            </div>
          </div>
        </div>
      </>
      <Bottom />
      <Footer />
    </div>
  );
};

export default Register1;
